/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import styles from './InfoBar.module.scss';

import * as _ from 'lodash';

import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import CustomerInfo from './Customer/CustomerInfo';
import ManagerBar from './Manager/ManagerBar';

const InfoBanner = () => {
  const manager = useSelector((state) =>
    state.customer ? state.customer.relationshipManager : null
  );

  function hasValue(value) {
    return !_.isUndefined(value) && !_.isEmpty(value);
  }

  function missingInfo() {
    return (
      _.isUndefined(manager) ||
      manager === null ||
      !hasValue(manager.fullName) ||
      !hasValue(manager.officePhone) ||
      !hasValue(manager.officeEmail) ||
      !hasValue(manager.officeLocation)
    );
  }

  const managerInfo = missingInfo() ? <></> : <ManagerBar />;
  return (
    <div id="info-bar" className={`${styles['info-bar']}`}>
      <div className={`${styles['customer-container']}`}>
        <CustomerInfo />
      </div>

      <div className={`${styles['info-bar-rt-container']}`}>
        <div className={`${styles['contact-container']}`}>{managerInfo}</div>
      </div>
    </div>
  );
};

InfoBanner.propTypes = {
  manager: PropTypes.object,
};

export default InfoBanner;
